import { v4 as uuidv4 } from "uuid"

export const data = {
  people: [
    {
      id: uuidv4(),
      name: "Sako M",
      img: "https://avatars3.githubusercontent.com/u/43357548?v=4",
      links: {
        website: "https://goupaz.com",
        linkedin: "https://www.linkedin.com/in/sakom/",
        github: "https://github.com/sakomws",
      },
      jobTitle: "DevOps",
      location: {
        city: "San Francisco",
        state: "California",
        country: "USA",
      },
    },
    {
      id: uuidv4(),
      name: "Nurlana Mollayeva",
      img: "https://avatars2.githubusercontent.com/u/74115466?v=4",
      links: {
        website: "https://goupaz.com",
        linkedin: "https://www.linkedin.com/in/nurlana1/",
        github: "https://github.com/Nurlana01",
      },
      jobTitle: "Community Manager",
      location: {
        city: "Baku",
        country: "Azerbaijan",
      },
    },
    {
      id: uuidv4(),
      name: "Emin Ghuliev",
      img: "https://i.imgur.com/ijV4k9L.jpg",
      links: {
        website: "https://goupaz.com",
        linkedin: "https://www.linkedin.com/in/emin-ghuliev-461a22129/",
        github: "https://github.com/eminghuliev",
      },
      jobTitle: "Community Leader",
      location: {
        city: "Baku",
        country: "Azerbaijan",
      },
    },
    {
      id: uuidv4(),
      name: "Rasim Abdullayev",
      img: "https://avatars2.githubusercontent.com/u/56521004?v=4",
      links: {
        website: "https://goupaz.com",
        linkedin: "https://www.linkedin.com/in/abdullayevrs/",
        github: "https://github.com/rasimab",
      },
      jobTitle: "Community Leader",
      location: {
        city: "Baku",
        country: "Azerbaijan",
      },
    },
    {
      id: uuidv4(),
      name: "Efkan Isazade",
      img: "https://avatars3.githubusercontent.com/u/39097733?v=4",
      links: {
        website: "https://efkan-isazade.com",
        linkedin: "https://www.linkedin.com/in/efkan-isazade/",
        github: "https://github.com/efe136",
      },
      jobTitle: "DevOps",
      location: {
        city: "Baku",
        country: "Azerbaijan",
      },
    },
    {
      id: uuidv4(),
      name: "Nihad Abbasov",
      img: "https://avatars2.githubusercontent.com/u/253398?v=4",
      links: {
        linkedin: "https://www.linkedin.com/in/nihadabbasov/",
        github: "https://github.com/NARKOZ",
      },
      jobTitle: "Software Architect",
      location: {
        city: "Kyiv",
        country: "Ukraine",
      },
    },
    {
      id: uuidv4(),
      name: "Orkhan Jafarov",
      img: "https://avatars2.githubusercontent.com/u/684926?v=4",
      links: {
        website: "https://goupaz.com",
        linkedin: "https://www.linkedin.com/in/orkhanjafarovr/",
        github: "https://github.com/gigantz",
      },
      jobTitle: "Community Leader",
      location: {
        city: "Edinburgh",
        state: "Scotland",
        country: "United Kingdom",
      },
    },
    {
      id: uuidv4(),
      name: "Nabi Nabizade",
      img: "https://avatars1.githubusercontent.com/u/17747430?v=4",
      links: {
        website: "https://goupaz.com",
        linkedin: "https://www.linkedin.com/in/nabi-nabizade/",
        github: "https://github.com/nabizade",
      },
      jobTitle: "Community Leader",
      location: {
        city: "Baku",
        country: "Azerbaijan",
      },
    },
    {
      id: uuidv4(),
      name: "Rovshan Musayev",
      img: "https://avatars1.githubusercontent.com/u/4127296?v=4",
      links: {
        website: "https://www.musayev.eu",
        linkedin: "https://www.linkedin.com/in/rovshan-musayev/",
        github: "https://github.com/arlington1985",
      },
      jobTitle: "Community Leader/Software Engineer",
      location: {
        city: "Prague",
        country: "Czechia",
      },
    },
    {
      id: uuidv4(),
      name: "Naseh Badalov",
      img: "https://avatars0.githubusercontent.com/u/18102077",
      links: {
        website: "https://nasehbadalov.com",
        linkedin: "https://www.linkedin.com/in/nasehbadalov/",
        github: "https://github.com/nasehbadalov",
      },
      jobTitle: "Frontend Engineer",
      location: {
        city: "Baku",
        country: "Azerbaijan",
      },
    },
    {
      id: uuidv4(),
      name: "Penny Fang",
      img: "https://avatars3.githubusercontent.com/u/10716182?v=4",
      links: {
        website: "https://goupaz.com",
        linkedin: "https://www.linkedin.com/in/le-penny-fang/",
        github: "https://github.com/Pennylele",
      },
      jobTitle: "Software Engineer",
      location: {
        city: "San Francisco",
        state: "California",
        country: "USA",
      },
    },

    {
      id: uuidv4(),
      name: "Ruslan Butdayev",
      img: "https://avatars3.githubusercontent.com/u/51235873",
      links: {
        website: "https://goupaz.com",
        linkedin: "https://www.linkedin.com/in/rbutdayev/",
        github: "https://github.com/rbutdayev",
      },
      jobTitle: "Doing IT",
      location: {
        city: "Baku",
        country: "Azerbaijan",
      },
    },
    {
      id: uuidv4(),
      name: "Aqil Aghamirzayev",
      img: "https://avatars2.githubusercontent.com/u/41694337?v=4",
      links: {
        website: "https://goupaz.com",
        linkedin: "https://www.linkedin.com/in/aqil-aghamirzayev-ab2379172/",
        github: "https://github.com/Aqilzeka",
      },
      jobTitle: "Java Developer",
      location: {
        city: "Baku",
        country: "Azerbaijan",
      },
    },
    {
      id: uuidv4(),
      name: "Jumshud Sultan",
      img:
        "https://avatars.githubusercontent.com/u/43217182?s=400&u=3222345f22e3ab866bb43c4412b574fbb76b13ad&v=4",
      links: {
        website: "https://goupaz.com",
        linkedin: "https://www.linkedin.com/in/jumshudsultan/",
        github: "https://github.com/jumshudsultan",
      },
      jobTitle: "Community Leader",
      location: {
        city: "Baku",
        country: "Azerbaijan",
      },
    },
    {
      id: uuidv4(),
      name: "Azay Jalil",
      img: "https://avatars.githubusercontent.com/u/41166569?v=4",
      links: {
        website: "",
        linkedin: "https://www.linkedin.com/in/jalil-azay/",
        github: "https://github.com/JalilAzay",
      },
      jobTitle: "Linux Engineer",
      location: {
        city: "Baku",
        country: "Azerbaijan",
      },
    },
    {
      id: uuidv4(),
      name: "Humay",
      img: "https://avatars.githubusercontent.com/u/47967308?v=4",
      links: {
        website: "https://goupaz.com",
        linkedin: "https://www.linkedin.com/in/humay555/",
        github: "https://github.com/Humay555",
      },
      jobTitle: "Contributor",
      location: {
        city: "Baku",
        country: "Azerbaijan",
      },
    },
    {
      id: uuidv4(),
      name: "Orkhan Huseynli",
      img: "https://avatars.githubusercontent.com/u/21221412?v=4",
      links: {
        website: "https://orkhan-huseyn.github.io/",
        linkedin: "https://www.linkedin.com/in/orkhanhuseynli/",
        github: "https://github.com/orkhan-huseyn",
      },
      jobTitle: "Tech Writer & Software Engineer",
      location: {
        city: "Kraków",
        country: "Poland",
      },
    },
  ],
}
